import { Grid, useMediaQuery } from '@mui/material'
import { PropsWithChildren, useMemo, useState } from 'react'
import { useGeoSearch, useInstantSearch } from 'react-instantsearch'
import { useVirtualSearchBox } from 'containers/search/useVirtualSearchBox'
import { SearchContent } from 'containers/seoPages/SearchContent'
import { SearchMapContainer } from 'containers/seoPages/map/SearchMapContainer'
import { isNotNullOrUndefined } from 'helpers/array'
import { AutocompleteItem } from 'interfaces/algolia'
import { unifiedColors } from 'styles/colors'
import { themeUtils } from 'styles/theme'
import { MapContainer, SearchContentContainer } from './ResultsContent.style'

export const ResultsContent = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)

  const { refine } = useGeoSearch()
  useVirtualSearchBox()

  const [highlightedEventId, setHighlightedEventId] = useState<number | null>(
    null
  )
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null)
  const [displayMap, setDisplayMap] = useState(false)
  const [expandedMap, setExpandedMap] = useState(false)

  const { results } = useInstantSearch()
  const eventsLatsAndLngs: GeoJSON.FeatureCollection<
    GeoJSON.Point,
    AutocompleteItem
  > = useMemo(
    () => ({
      type: 'FeatureCollection',
      features:
        results?.hits
          .filter(
            (hit: AutocompleteItem) =>
              isNotNullOrUndefined(hit._highlightResult._geo) &&
              hit.eventCountry === 'France'
          )
          .map((hit: AutocompleteItem) => ({
            id: hit._highlightResult.objectID.value,
            geometry: {
              coordinates: [
                Number(hit._highlightResult._geo!.lng.value),
                Number(hit._highlightResult._geo!.lat.value)
              ],
              type: 'Point'
            },
            properties: {
              'marker-color': unifiedColors.button.primary.default,
              'marker-size': 'small',
              'marker-symbol': 'racetrack',
              ...hit
            },
            type: 'Feature'
          })) ?? []
    }),
    [results.hits]
  )

  return (
    <Grid container spacing={{ md: 2 }} m={{ md: 0 }} width={{ md: '100%' }}>
      <SearchContentContainer
        size={{ md: expandedMap ? 12 : 7 }}
        p={2}
        mt={2}
        bgcolor={unifiedColors.surface.subdued}
        borderRadius={2}
        width="auto"
        $expandedMap={expandedMap}
      >
        {children}
        <SearchContent
          highlightedEventId={highlightedEventId}
          setSelectedEventId={setSelectedEventId}
          displayMap={displayMap}
          setDisplayMap={setDisplayMap}
          expandedMap={expandedMap}
        />
      </SearchContentContainer>
      <MapContainer size={{ md: expandedMap ? 12 : 5 }}>
        {(!isMobile || displayMap) && (
          <SearchMapContainer
            geoJson={eventsLatsAndLngs}
            defaultFullScreen={isMobile}
            highLightEvent={setHighlightedEventId}
            selectedEventId={selectedEventId}
            refineGeoLocation={refine}
            setExpandedMap={setExpandedMap}
            expandedMap={expandedMap}
            hideMap={() => setDisplayMap(false)}
          />
        )}
      </MapContainer>
    </Grid>
  )
}
